import { TabBar, TabPanel } from './components';

export const Tabs = {
  Bar: TabBar,
  Panel: TabPanel,
} as const;
